module.exports = __webpack_public_path__ + "static/media/Read-Bold_V1100.13431fdd.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read/Read-Bold_V1100.eot
// module id = 651
// module chunks = 0